import { css } from '@understory-io/leaf/css';

const CHECKOUT_MAX_WIDTH = '[986px]';
export const maxWidthContentCheckout = css({
  maxWidth: CHECKOUT_MAX_WIDTH,
  marginInline: 'auto',
  width: 'full',
});

export const maxWidthContent = css({
  maxWidth: 'breakpoint-desktop',
  marginInline: 'auto',
  width: 'full',
});

export const focusVisibleRing = css({
  _focusVisible: {
    outline: 'medium',
    outlineColor: 'border.focus',
    outlineOffset: 'tiny',
    borderRadius: 'small',
  },
});

export const showForBreakpointAndUp = (
  breakpoint: 'tablet' | 'desktop' | 'wideDesktop',
  displayMode: string = 'block'
) =>
  css({
    display: { base: 'none', [breakpoint]: displayMode },
  });
